const regexCNPJ = /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/

function matchNumbers(value: string | number | number[]) {
  if (typeof value === 'string') {
    return (value.match(/\d/g) || []).map(Number)
  } else if (typeof value === 'number') {
    return value.toString().match(/\d/g)?.map(Number) || []
  } else if (Array.isArray(value)) {
    return value.filter((v) => typeof v === 'number' && v >= 0 && v <= 9)
  }
  return []
}

function validCalc(length: number, numbers: number[]) {
  const weights = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
  let sum = 0
  for (let i = 0; i < length; i++) {
    sum += numbers[i] * weights[weights.length - length + i]
  }
  const remainder = sum % 11
  return remainder < 2 ? 0 : 11 - remainder
}

export function isValidCNPJ(value: string | number | number[] = '') {
  if (!value) return false

  const isString = typeof value === 'string'
  const validTypes = isString || Number.isInteger(value) || Array.isArray(value)

  if (!validTypes) return false

  const numbers = matchNumbers(value)

  if (numbers.length !== 14) return false

  const items = [...new Set(numbers)]
  if (items.length === 1) return false

  const digits = numbers.slice(12)

  const digit0 = validCalc(12, numbers)
  if (digit0 !== digits[0]) return false

  const digit1 = validCalc(13, numbers)
  return digit1 === digits[1]
}

export function formatCNPJ(value: string | number | number[] = '', validate: boolean = true) {
  const numbers = matchNumbers(value)

  // Se tiver 15 dígitos, remover o último dígito
  if (numbers.length === 15) {
    numbers.pop()
  }

  // Verifica se o valor é válido
  const valid = isValidCNPJ(numbers)

  if (!valid && validate) {
    //console.log(`CNPJ inválido: ${value}`)
    // Retorna um CNPJ formatado com "xx"
    return 'xx.xxx.xxx/xxxx-xx'
  }

  const text = numbers.join('')

  const format = text.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')

  return format
}

// // Exemplo de uso
// const cnpj1 = "662226486871750";
// const formattedCNPJ1 = formatCNPJ(cnpj1);
// console.log(formattedCNPJ1); // Deve retornar "xx.xxx.xxx/xxxx-xx"

// const cnpj2 = "55083808000171";
// const formattedCNPJ2 = formatCNPJ(cnpj2);
// console.log(formattedCNPJ2); // Deve retornar "55.083.808/0001-71"
